import { render, staticRenderFns } from "./AllBid.vue?vue&type=template&id=384b702f&scoped=true&"
import script from "./AllBid.vue?vue&type=script&lang=js&"
export * from "./AllBid.vue?vue&type=script&lang=js&"
import style0 from "./AllBid.vue?vue&type=style&index=0&id=384b702f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b702f",
  null
  
)

export default component.exports